"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = exports.auth = exports.del = exports.put = exports.post = exports.get = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
/**
 * Gets a model or collection or models
 * @param url Example: https://www.project.com/users or https://www.project.com/users/1
 * @param jwt The JWT used for authentication and authorization
 */
function get(url, jwt = null) {
    return __awaiter(this, void 0, void 0, function* () {
        var response;
        try {
            response = yield (0, cross_fetch_1.default)(url, createRequestInfo({
                method: 'GET',
                jwt,
            }));
            return yield createStrapiFetchResponse(response);
        }
        catch (e) {
            return createStrapiFetchResponseError(e, [], response ? response.status : null);
        }
    });
}
exports.get = get;
/**
 * Creates a model
 * @param url Example: https://www.project.com/users
 * @param body The model object. The function will take care of serialization
 * @param jwt The JWT used for authentication and authorization
 */
function post(url, body, jwt = null) {
    return __awaiter(this, void 0, void 0, function* () {
        var response;
        try {
            response = yield (0, cross_fetch_1.default)(url, createRequestInfo({
                method: 'POST',
                body,
                jwt,
            }));
            return yield createStrapiFetchResponse(response);
        }
        catch (e) {
            return createStrapiFetchResponseError(e, [], response ? response.status : null);
        }
    });
}
exports.post = post;
/**
 * Updates a model
 * @param url Example: https://www.project.com/users/1
 * @param body The model object. The function will take care of serialization
 * @param jwt The JWT used for authentication and authorization
 */
function put(url, body, jwt = null) {
    return __awaiter(this, void 0, void 0, function* () {
        var response;
        try {
            response = yield (0, cross_fetch_1.default)(url, createRequestInfo({
                method: 'PUT',
                body,
                jwt,
            }));
            return yield createStrapiFetchResponse(response);
        }
        catch (e) {
            return createStrapiFetchResponseError(e, [], response ? response.status : null);
        }
    });
}
exports.put = put;
/**
 * Deletes a model
 * @param url Example: https://www.project.com/users/1
 * @param jwt The JWT used for authentication and authorization
 */
function del(url, jwt = undefined) {
    return __awaiter(this, void 0, void 0, function* () {
        var response;
        try {
            response = yield (0, cross_fetch_1.default)(url, createRequestInfo({
                method: 'DELETE',
                jwt,
            }));
            return yield createStrapiFetchResponse(response);
        }
        catch (e) {
            return createStrapiFetchResponseError(e, [], response ? response.status : null);
        }
    });
}
exports.del = del;
/**
 * Gets the JWT using identifier and password
 * @param url Example: https://www.project.com/auth/local
 */
function auth(url, identifier, password) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield post(url, {
            identifier,
            password,
        });
        if (response.ok) {
            return response;
        }
        else {
            const payload = response.payload;
            return createStrapiFetchResponseError(payload === null || payload === void 0 ? void 0 : payload.error, (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.message[0]) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b.map((m) => m.message)) !== null && _c !== void 0 ? _c : [], response ? response.status : null);
        }
    });
}
exports.auth = auth;
/**
 * GraphQL query
 * @param url Example: https://www.project.com/graphql
 * @param query Example: 'users(where: { confirmed: true }) { id, email }'
 */
function query(url, query, jwt = undefined) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield get(`${url}?query={${query}}`.replace(/\s/g, ''), jwt);
        if (response.ok) {
            // Take first property of the object 'data'
            for (var prop in response.payload.data) {
                response.payload = response.payload.data[prop];
                break;
            }
        }
        return response;
    });
}
exports.query = query;
function createRequestInfo(options) {
    var headers = {
        'Content-Type': 'application/json',
    };
    if (options.jwt)
        headers = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${options.jwt}` });
    return {
        method: options.method,
        body: JSON.stringify(options.body),
        headers,
    };
}
function createStrapiFetchResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = yield response.json();
        return {
            ok: response.ok,
            status: response.status,
            messages: [],
            data: payload,
            payload,
        };
    });
}
function createStrapiFetchResponseError(error, messages, status) {
    return {
        ok: false,
        status,
        error,
        messages,
    };
}
//# sourceMappingURL=index.js.map